import React from 'react';
import { Link } from 'react-router-dom';
import './Championships.css';

export default function Championships({ championships, championshipDetails, leagueResults, loading, handleChampionshipSelection }) {

  const renderCustomTable = (details) => {
    if (details.championshipName === 'Winter Community Cup Championship Series 2024') {
      return (
        <div className="scrollable-container">
          <table>
            <thead>
              <tr>
                <th>Pos</th>
                <th>Driver</th>
                <th>1</th>
                <th>Total</th>
                <th>Best 6</th>
              </tr>
            </thead>
            <tbody>
              {details.championshipResults.map((result, index) => (
                <tr key={index}>
                  <td>{result.position}</td>
                  <td>
                    {result.customer_id ? (
                      <Link to={`/driver/${result.customer_id}`} className="driver-link">
                        {result.customer_name}
                      </Link>
                    ) : (
                      result.customer_name
                    )}
                  </td>
                  <td>{result.events[0]?.score || '-'}</td>
                  <td>{result.score}</td>
                  <td>{result.events[0]?.score || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    } else if (details.championshipName === 'October Radical League') {
      return (
        <div className="scrollable-container">
          <table>
            <thead>
              <tr>
                <th>Pos</th>
                <th>Driver</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>7</th>
                <th>8</th>
                <th>Total</th>
                <th>Best 8</th>
              </tr>
            </thead>
            <tbody>
              {details.championshipResults.map((result, index) => (
                <tr key={index}>
                  <td>{result.position}</td>
                  <td>
                    {result.customer_id ? (
                      <Link to={`/driver/${result.customer_id}`} className="driver-link">
                        {result.customer_name}
                      </Link>
                    ) : (
                      result.customer_name
                    )}
                  </td>
                  {Array.from({ length: 8 }).map((_, i) => (
                    <td key={i}>{result.events[i]?.score || '-'}</td>
                  ))}
                  <td>{result.score}</td>
                  <td>{result.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    } else {
      return (
        <div className="scrollable-container">
          <table>
            <thead>
              <tr>
                <th>Pos</th>
                <th>Driver</th>
                <th>1</th>
                <th>2</th>
                <th>3</th>
                <th>4</th>
                <th>5</th>
                <th>6</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {details.championshipResults.map((result, index) => (
                <tr key={index}>
                  <td>{result.position}</td>
                  <td>
                    {result.customer_id ? (
                      <Link to={`/driver/${result.customer_id}`} className="driver-link">
                        {result.customer_name}
                      </Link>
                    ) : (
                      result.customer_name
                    )}
                  </td>
                  {Array.from({ length: 6 }).map((_, i) => (
                    <td key={i}>{result.events[i]?.score || '-'}</td>
                  ))}
                  <td>{result.score}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  };

  return (
    <div className="championships-page">
      <br />
      <h2 className="title">Championships</h2>

      <div className="championships-dropdown-container">
        <select
          className="event-dropdown"
          onChange={(e) => handleChampionshipSelection(e.target.value)}
          defaultValue=""
        >
          <option value="" disabled>Select a Championship</option>
          {championships.map((championship) => (
            <option key={championship.id} value={championship.id}>
              {championship.name}
            </option>
          ))}
        </select>
      </div>

      {loading && (
        <div className="socket">
          <div className="gel center-gel">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
          <div className="gel c1 r1">
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
        </div>
      )}

      {!loading && championshipDetails && (
        <div className="championship-details">
          <h3>{championshipDetails.championshipName} Summary</h3>
          {renderCustomTable(championshipDetails)}
        </div>
      )}

      {!loading && leagueResults.length > 0 && leagueResults.map((league, index) => (
        league.results.length > 0 && (
          <div key={index} className="league-section">
            <h3>{league.eventName}</h3>
            <div className="scrollable-container">
              <table>
                <thead>
                  <tr>
                    <th>Pos</th>
                    <th>Driver</th>
                    <th>Qual Points</th>
                    <th>Race Points</th>
                    <th>Best Prac Lap</th>
                    <th>Best Qual Lap</th>
                    <th>Best Race Lap</th>
                    <th>Wins</th>
                    <th>Total Points</th>
                  </tr>
                </thead>
                <tbody>
                  {league.results.map((result, i) => (
                    <tr key={i}>
                      <td>{result.position}</td>
                      <td>
                        {result.customer_id ? (
                          <Link to={`/driver/${result.customer_id}`} className="driver-link">
                            {result.customer_name}
                          </Link>
                        ) : (
                          result.customer_name
                        )}
                      </td>
                      <td>{result.qualification_points}</td>
                      <td>{result.race_points}</td>
                      <td>{result.best_practice_lap_time_str}</td>
                      <td>{result.best_qualification_lap_time_str}</td>
                      <td>{result.best_race_lap_time_str}</td>
                      <td>{result.race_wins}</td>
                      <td>{result.total_points}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      ))}
    </div>
  );
}
